module.exports = __webpack_public_path__ + "static/media/home-button.2c82ac21.png";